var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2175_30328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9805 31.32L62.0405 43.86C59.5205 54.69 54.5405 59.07 45.1805 58.17C43.6805 58.05 42.0605 57.78 40.3205 57.36L35.2805 56.16C22.7705 53.19 18.9005 47.01 21.8405 34.47L24.7805 21.9C25.3805 19.35 26.1005 17.13 27.0005 15.3C30.5105 8.04002 36.4805 6.09002 46.5005 8.46002L51.5105 9.63002C64.0805 12.57 67.9205 18.78 64.9805 31.32Z",
    stroke: "#A3A1AA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1791 58.17C43.3191 59.43 40.9791 60.48 38.1291 61.41L33.3891 62.9701C21.4791 66.8101 15.2091 63.6001 11.3391 51.69L7.49907 39.8401C3.65907 27.9301 6.83907 21.63 18.7491 17.79L23.4891 16.23C24.7191 15.84 25.8891 15.51 26.9991 15.3C26.0991 17.13 25.3791 19.35 24.7791 21.9001L21.8391 34.47C18.8991 47.0101 22.7691 53.19 35.2791 56.16L40.3191 57.3601C42.0591 57.7801 43.6791 58.05 45.1791 58.17Z",
    stroke: "#A3A1AA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6093 19.7927C40.9188 20.2304 41.6254 21.6468 41.1877 22.9563L39.6024 27.6983L34.8603 26.113L36.4456 21.371C36.8834 20.0615 38.2998 19.3549 39.6093 19.7927Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7304 25.1828C57.0399 25.6206 57.7465 27.037 57.3087 28.3465L55.7234 33.0885L50.9814 31.5032L52.5667 26.7611C53.0045 25.4517 54.4209 24.745 55.7304 25.1828Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.119 39.0847C39.5 38.2091 36.6672 39.6224 35.7916 42.2414L31.998 40.9731C33.574 36.259 38.6731 33.7151 43.3872 35.291C48.1013 36.867 50.6453 41.9661 49.0693 46.6802L45.2757 45.412C46.1512 42.7931 44.7379 39.9602 42.119 39.0847Z",
    fill: "#A3A1AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2175_30328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadReport);
export default __webpack_public_path__ + "static/media/sadReport.52aad314.svg";
export { ForwardRef as ReactComponent };